import { Component, Input, OnInit } from '@angular/core';
import { CustomerType, CUSTOMER_TYPE_OPTIONS } from 'src/app/models/enums/customer-type';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from 'src/app/services/alert.service';
import { Customer } from 'src/app/models/customer/customer';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'app-customer-create-edit-modal',
  templateUrl: './customer-create-edit-modal.component.html',
  styleUrls: ['./customer-create-edit-modal.component.scss']
})
export class CustomerCreateEditModalComponent implements OnInit {

  @Input() isCreate: boolean = true;
  @Input() customerId: number;
  request: Customer = {isActive: true}
  show = true;
  isDisabled: boolean = false;

  /**
   * Müşteri tipi Customers tablosunda saklanıyor (SUB_008); ekranda ayrı bir bayrak
   * tutulmuyor, doğrudan kaydedilecek alan bağlanıyor. e-Belge taraf bilgisi
   * (ad/soyad + TCKN mi, ünvan + VKN mi) bu alandan kuruluyor.
   */
  CustomerType = CustomerType;
  customerTypeOptions = CUSTOMER_TYPE_OPTIONS;
  constructor(
    private service: CustomerService,
    private alertService: AlertService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    public activeModal: NgbActiveModal,
    // private uploadService: UploadService

  ) { }

  ngOnInit(): void {
    // Yeni kayıtta da tip gönderilsin; varsayılan gerçek kişi.
    if (this.isCreate)
      this.request.customerType = CustomerType.Person;

    if(!this.isCreate && !this.customerId){
      let id = this.route.snapshot.params['id'];
      this.service.find(id).toPromise().then(res => {
        this.request = res.data;
        this.resolveCustomerType();
      })
    }

    if(!this.isCreate && this.customerId){
      this.service.find(this.customerId).toPromise().then(res => {
        this.request = res.data;
        this.resolveCustomerType();
      })
    }

  }

  /** Şablonun kısayolu; kimlik alanları tipe göre gösteriliyor. */
  get isCompany(): boolean {
    return this.request?.customerType === CustomerType.Company;
  }

  /**
   * Kayıtlı müşterinin tipi karttan okunur. Alan boş gelirse (tipi göndermeyen eski
   * bir istemcinin açtığı kayıt) VKN doluluğuna bakılır — SUB_008 geriye doldurması
   * da aynı kuralı kullanıyor.
   */
  private resolveCustomerType() {
    if (this.request.customerType === CustomerType.Company
      || this.request.customerType === CustomerType.Person)
      return;

    this.request.customerType = (this.request.taxNumber || this.request.taxAdministration)
      ? CustomerType.Company
      : CustomerType.Person;
  }

  /**
   * Tip değişince diğer tipin kimlik alanları temizlenir; aksi halde ekranda
   * görünmeyen eski bir VKN kayda gidip arka ucun belge tipi seçimini bozar.
   */
  onCustomerTypeChange(type: CustomerType) {
    if (this.request.customerType === type)
      return;
    this.request.customerType = type;
    if (type === CustomerType.Person) {
      this.request.taxNumber = null;
      this.request.taxAdministration = null;
    }
    else {
      this.request.tckn = null;
    }
  }
  onSubmit() {
    if (this.isValid()) {
    if(this.isCreate){
      this.isDisabled = true;
      this.request.displayName = this.request.displayName.toLocaleUpperCase(["Turkish","tr"])
      this.service.create(this.request).toPromise().then(res => {
        this.isDisabled = false;
        if(res.isSuccess){
          this.modalService.dismissAll();
          this.alertService.showSuccess('Yeni müşteri eklendi.')
          this.service.refreshIndex.next();
        }
        }).catch(err => this.isDisabled = false)
    }
    if(!this.isCreate){
      this.request.displayName = this.request.displayName.toLocaleUpperCase(["Turkish","tr"])
      this.service.update(this.request).toPromise().then(res => {
        this.isDisabled = false;
        if(res.isSuccess){
          this.modalService.dismissAll();
          this.alertService.showSuccess('Müşteri güncellendi.')
          this.service.refreshIndex.next();
        }
      }).catch(err => this.isDisabled = false)
    }
  }
}

  isValid(): boolean {
    let messages: string[] = [];
    if (!this.request.name)
      messages.push('Müşteri adı boş olmamalı.')
    if (!this.request.displayName)
      messages.push('Müşteri kısa adı boş olmamalı.')
    if (!this.isCompany && this.request.tckn && !/^[0-9]{11}$/.test(this.request.tckn.trim()))
      messages.push('TCKN 11 haneli ve sadece rakamlardan oluşmalı.')
    if (this.isCompany && this.request.taxNumber && !/^[0-9]{10}$/.test(this.request.taxNumber.trim()))
      messages.push('Vergi numarası 10 haneli ve sadece rakamlardan oluşmalı.')
    // Arka uçtaki CustomerCERequestValidator ile aynı kural: gerçek kişide e-belge
    // ad ve soyadı ayrı istiyor (UBL PersonName). Burada da bakılmazsa kullanıcı
    // hatayı ancak kaydettikten sonra sunucudan görüyor.
    if (!this.isCompany && this.request.name && !this.request.name.trim().includes(' '))
      messages.push('Gerçek kişide ad ve soyad birlikte yazılmalı.')
    if (this.request.postalCode && !/^[0-9]{5}$/.test(this.request.postalCode.trim()))
      messages.push('Posta kodu 5 haneli ve sadece rakamlardan oluşmalı.')
    if (messages.length > 0) {
      this.alertService.showErrorsToast(messages);
      return false
    }
    else return true;
  }

  onFilechange(event: any) {
    // this.file = event.target.files[0]
  }

  upload() {
    // if (this.file) {
    //   this.uploadService.uploadfile(this.file).subscribe(resp => {
    //     alert("Uploaded")
    //   })
    // } else {
    //   alert("Please select a file first")
    // }
  }

}
